import moment from "moment";
import { dateTimeFormats } from "../utils/helper";
import http from "./httpService";

const baseUrl = `/attendance`;

export const getAttendanceLogs = async () => {
  try {
    const { data } = await http.get(baseUrl);
    return data;
  } catch (err) {
    return null;
  }
};

// `range` is { startDate, endDate } as YYYY-MM-DD. Passing it makes the server scope the
// query to those dates instead of returning only the latest records — required for the
// profile's date filter to reach older months.
export const getMemberAttendanceLogs = async (memberId, range = {}) => {
  try {
    const { startDate, endDate } = range;
    const params = startDate && endDate ? { startDate, endDate } : {};
    const { data } = await http.get(`${baseUrl}/member/${memberId}`, { params });
    return data.logs;
  } catch (err) {
    return null;
  }
};

// Break/back times of one attendance session -> [{ breakStart, breakEnd, duration, isOpen }].
// Loaded on demand when the break cell is expanded.
export const getSessionBreaks = async (attendanceId) => {
  try {
    const { data } = await http.get(`${baseUrl}/${attendanceId}/breaks`);
    return data.breaks || [];
  } catch (err) {
    return null;
  }
};

export const getMemberAverageWorkingTime = async (memberId) => {
  try {
    const {
      data: { averageWorkingHour },
    } = await http.get(`${baseUrl}/member/${memberId}/average-working-time`);
    return averageWorkingHour;
  } catch (err) {
    return null;
  }
};

export const updateAttendanceLog = async (id, data) => {
  try {
    const {
      data: { log },
      status,
    } = await http.put(`${baseUrl}/${id}`, data);
    return { status, log };
  } catch (err) {
    return {};
  }
};

export const createAttendanceLog = async (data) => {
  try {
    const {
      data: { log },
      status,
    } = await http.post(`${baseUrl}`, data);
    return { status, log };
  } catch (err) {
    return {};
  }
};

export const deleteAttendanceLog = async (id) => {
  try {
    const { status } = await http.delete(`${baseUrl}/${id}`);
    return { status };
  } catch (err) {
    return {};
  }
};

export const getLogHistory = async ({
  startDate,
  endDate = null,
  page = 1,
  pageSize = 50,
  memberIds = "",
  breakOnly = false,
  officeOnly = false,
  remoteOnly = false,
  lateOnly = false,
}) => {
  try {
    const {
      data: { logs, pagination, summary },
      status,
    } = await http.get(`${baseUrl}/history`, {
      params: {
        startDate: moment(startDate).format(dateTimeFormats.yearMonthDate),
        endDate: endDate
          ? moment(endDate).format(dateTimeFormats.yearMonthDate)
          : null,
        page,
        pageSize,
        memberIds,
        breakOnly,
        officeOnly,
        remoteOnly,
        lateOnly,
      },
    });

    return { status, logs, pagination, summary };
  } catch (err) {
    return {};
  }
};

export const downloadLogs = async (startDate, endDate, memberIds) => {
  const params = {};
  startDate && (params.startDate = startDate);
  endDate && (params.endDate = endDate);
  memberIds && (params.memberIds = memberIds);

  const { data, headers } = await http.get(`/download`, {
    responseType: "blob",
    params,
  });

  const href = URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = href;
  link.setAttribute(
    "download",
    headers["content-disposition"]
      .match(/filename="[\w\W]*?"/gim)?.[0]
      .replace(/filename="|"$/gim, "")
  );

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(href);

  return true;
};
